import * as React from 'react';

//hook
import { useState, useEffect } from 'react';
import { UserConsumer } from '../hooks/context/UserContext';

//component
import CompletedClientField from '../component/CompletedClientField';
import CompletedDriverField from '../component/CompletedDriverField';
import CompletedHostField from '../component/CompletedHostField';
import Loader from '../component/Loader';

//translate
import { useTranslation } from 'react-i18next';

//api
import { GetRoletProfile } from '../api/completedRole/GetRoletProfile';

//type
import { clientProfileType, driverProfileType, hostProfileType } from '../api/completedRole/type/CompletedRoleType';

//mui
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';



interface completeRoleProps {
    openCompletedProfile: boolean
    setOpenCompletedProfile:(open:boolean)=>void
}
const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const CompletedRole = ({openCompletedProfile, setOpenCompletedProfile}:completeRoleProps) => {
    const { t } = useTranslation();
    let {userData,setTheme, theme} = UserConsumer()
    const [loading, setLoading] = useState<boolean>(false)
    const [loadingGetRolet, setLoadingGetRolet] = useState<boolean>(false)
    const [RoleLicenseFront, setRoleLicenseFront] = useState<string>("");
    const [RoleLicenseBack, setRoleLicenseBack] = useState<string>("");
    const [driverPichture, setDriverPichture] = useState<string>("");
    const [hostCommercialRegistry, setHostCommercialRegistry] = useState<string>("");
    const [clientProfile, setClientProfile] = useState<clientProfileType>(
        {
            id: 0, 
            billing_address: '', 
            license_number: '', 
            front_image_url: null,
            background_image_url: null
        })
    const [driverProfile, setDriverProfile] = useState<driverProfileType>(
        {
            id: 0,
            picture_url: null,
            desired_wage: 0,
            price_per_hour: 0,
            extra_hour_price: 0,
            front_license_image_url: null,
            background_license_image_url: null
        })
    const [hostProfile, setHostProfile] = useState<hostProfileType>(
        {
            id:0,
            user_id:0,
            is_company:0,
            company_name:"",
            commercial_registry:null,
            is_confirmed:false,
        })

    //get the data if the user is completed
    useEffect(() => {
        const RoleProfile = async ()=>{
            if (openCompletedProfile) {
                if (theme === "client" && userData?.is_client) {
                    setLoadingGetRolet(true)
                    const result = await GetRoletProfile(theme)
                    setClientProfile(result.data)
                    if(result) {
                        setLoadingGetRolet(false)
                    }
                } else if (theme === "driver" && userData?.is_driver) {
                    setLoadingGetRolet(true)
                    const result = await GetRoletProfile(theme)
                    setDriverProfile(result.data)
                    if(result) {
                        setLoadingGetRolet(false)
                    }
                }
                else if (theme === "host" && userData?.is_host) {
                    setLoadingGetRolet(true)
                    const result = await GetRoletProfile(theme)
                    setHostProfile(result.data)
                    if(result) {
                        setLoadingGetRolet(false)
                    }
                }
                else {
                    
                }
            }
        }
        RoleProfile()
    }, [openCompletedProfile]);

    const handleCloseDilaog = () => {
        setTheme("client")
        setOpenCompletedProfile(false)
        setRoleLicenseFront('')
        setRoleLicenseBack('')
        setDriverPichture('')
        setClientProfile({    
            id: 0,
            billing_address: "",
            license_number: "",
            front_image_url: null,
            background_image_url: null,
        })
        setDriverProfile({
            id: 0,
            picture_url: null,
            desired_wage: 0,
            price_per_hour: 0,
            extra_hour_price: 0,
            front_license_image_url: null,
            background_license_image_url: null
        })
        setHostProfile({   
            id:0,
            user_id:0,
            is_company:0,
            company_name:"",
            commercial_registry:null,
            is_confirmed:false,
        })
    }
    return (
        <div>
            <Dialog 
            open={openCompletedProfile}
            onClose={handleCloseDilaog}
            slots={{
            transition: Transition,
            }}
            disableRestoreFocus
            maxWidth="sm"
            fullWidth 
            >
                <DialogTitle className='flex gap-3'>
                <p>{t(`complete_profile_as_a_${theme}`)}</p>
                </DialogTitle>
                <DialogContent>
                    {
                    userData?.is_client || userData?.is_host || userData?.is_driver 
                    ? 
                    (
                        loadingGetRolet 
                        ?
                        (
                        <Box sx={{ display: 'flex', justifyContent: "center"}}>
                            <CircularProgress />
                        </Box>
                        )
                        : 
                        ( 
                        theme === "client"
                        ?                    
                        <CompletedClientField 
                        setOpenCompletedProfile={setOpenCompletedProfile}
                        loading={loading}
                        setLoading={setLoading}
                        RoleLicenseFront={RoleLicenseFront}
                        setRoleLicenseFront={setRoleLicenseFront}
                        RoleLicenseBack={RoleLicenseBack}
                        setRoleLicenseBack={setRoleLicenseBack}
                        clientProfile={clientProfile} 
                        setClientProfile={setClientProfile}
                        />
                        : theme === "driver"
                        ?
                        <CompletedDriverField 
                        setOpenCompletedProfile={setOpenCompletedProfile}
                        loading={loading}
                        setLoading={setLoading}
                        RoleLicenseFront={RoleLicenseFront}
                        setRoleLicenseFront={setRoleLicenseFront}
                        RoleLicenseBack={RoleLicenseBack}
                        setRoleLicenseBack={setRoleLicenseBack}
                        driverProfile={driverProfile} 
                        setDriverProfile={setDriverProfile}
                        driverPichture={driverPichture}
                        setDriverPichture={setDriverPichture}
                        />
                        :
                        <CompletedHostField 
                        setOpenCompletedProfile={setOpenCompletedProfile}
                        loading={loading}
                        setLoading={setLoading}
                        hostProfile={hostProfile}
                        setHostProfile={setHostProfile}
                        hostCommercialRegistry={hostCommercialRegistry}
                        setHostCommercialRegistry={setHostCommercialRegistry}
                        />
                        )
                    )
                    :
                    (
                        theme === "client"
                        ?                    
                        <CompletedClientField 
                        setOpenCompletedProfile={setOpenCompletedProfile}
                        loading={loading}
                        setLoading={setLoading}
                        RoleLicenseFront={RoleLicenseFront}
                        setRoleLicenseFront={setRoleLicenseFront}
                        RoleLicenseBack={RoleLicenseBack}
                        setRoleLicenseBack={setRoleLicenseBack}
                        clientProfile={clientProfile} 
                        setClientProfile={setClientProfile}
                        />
                        : theme === "driver"
                        ?
                        <CompletedDriverField 
                        setOpenCompletedProfile={setOpenCompletedProfile}
                        loading={loading}
                        setLoading={setLoading}
                        RoleLicenseFront={RoleLicenseFront}
                        setRoleLicenseFront={setRoleLicenseFront}
                        RoleLicenseBack={RoleLicenseBack}
                        setRoleLicenseBack={setRoleLicenseBack}
                        driverProfile={driverProfile} 
                        setDriverProfile={setDriverProfile}
                        driverPichture={driverPichture}
                        setDriverPichture={setDriverPichture}
                        />
                        :
                        <CompletedHostField 
                        setOpenCompletedProfile={setOpenCompletedProfile}
                        loading={loading}
                        setLoading={setLoading}
                        hostProfile={hostProfile}
                        setHostProfile={setHostProfile}
                        hostCommercialRegistry={hostCommercialRegistry}
                        setHostCommercialRegistry={setHostCommercialRegistry}
                        />
                    )
                    }
                </DialogContent>
            </Dialog>
        </div>
    )
}

export default CompletedRole